import React, { memo } from 'react';
import Arrow from './Arrow/Arrow';
import { NavigationProps } from '../types';
import { usePrevNextButtons } from '../hooks/usePrevNextButtons';

function ArrowNavigation({ emblaApi, onNavButtonClick }: NavigationProps) {
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons({ emblaApi, onNavButtonClick });

  return (
    <>
      <Arrow
        onClick={onPrevButtonClick}
        disabled={prevBtnDisabled}
        type="Back"
      />
      <Arrow
        onClick={onNextButtonClick}
        disabled={nextBtnDisabled}
        type="Forward"
      />
    </>
  );
}

export default memo(ArrowNavigation);
